import { render, staticRenderFns } from "./DeptConsume.vue?vue&type=template&id=6a8fb20c&scoped=true"
import script from "./DeptConsume.vue?vue&type=script&lang=js"
export * from "./DeptConsume.vue?vue&type=script&lang=js"
import style0 from "./DeptConsume.vue?vue&type=style&index=0&id=6a8fb20c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fb20c",
  null
  
)

export default component.exports